import type { FaireProductEntity } from "../../entity_types/product";

export const p_tee4rcq898: FaireProductEntity = {
  token: "p_tee4rcq898",
  type: "product",
  name: "Cut Grass Special – Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/18f57996658b601cb2b635ee714b83cfb39e19048f8b99a2f33bb6363b11f502.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e844d231dc7898036d6521fa5d663777c3abcc2d9bf60a4c37252d07480889d3.jpeg",
    "https://cdn.faire.com/fastly/34258842815ab714020c664994e14d617c2c7722da772208356b39d9e096f155.jpeg",
    "https://cdn.faire.com/fastly/99629845fda9a94ad1d296487d52650846d4077a0cc9c453d68a269af820b66c.jpeg",
    "https://cdn.faire.com/fastly/dac936c136439e5dce69e03119836478cc75f67ed6e18fbb647f4cc77b7208c7.jpeg",
    "https://cdn.faire.com/fastly/ad63abf533efb8e446d6e574db7a04e8d7ec6d0b3c4bd68452a72b1d759d1a8a.jpeg",
  ],
  priceDollars: 11,
  description:
    "*LIMITED EDITION* \n\nGreen, damp, and vegetal. Inspired by freshly mowed lawns, midday picnics, the earth below still dewy from the morning. Heady hyacinth and crushed moss blend with the nostalgic scent of damp fields for a refreshingly clean, almost effervescent experience. \n",
  tags: [],
  msrpDollars: 23.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:44.208Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
